import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { WebGLPlayer } from "../Components/Player/WebGLPlayer";
import { LeftArrow } from "../Assets/iconshere";

const EventScreen = () => {
  const userData = useSelector((state) => state.userSlice);
  const params = useParams();
  const navigate = useNavigate();
  const handleBack = () => {
    if (userData.token && userData.user.permissions.includes("METAVERSE.EVENTS")) {
      navigate("/events");
    } else if (userData.token) {
      navigate(`/dashboard/${userData.user.uuid}`);
    } else {
      navigate(`/`);
    }
  };
  return (
    <>
      <div className="event-parent">
        <div className="d-flex align-items-center justify-content-start pb-2" style={{ width: "90vw" }}>
          <button onClick={handleBack} className="backbtn cursor-pointer px-2" title="Back">
            <LeftArrow />
            Back
          </button>
        </div>
        <WebGLPlayer type={"event"} uuid={params.id} />
      </div>
    </>
  );
};

export default EventScreen;
